import { render } from "./TickControl.vue?vue&type=template&id=ddabda9c&ts=true"
import script from "./TickControl.vue?vue&type=script&lang=ts"
export * from "./TickControl.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__